<template>
  <NuxtLink
    :href="resolveLocalePath(post.url)"
    :class="bem({
      'dark-mobile': mobileLayout === 'normal'
    })"
    @click="handleLinkClick"
  >
    <div :class="bem('post-media')">
      <BaseVideo
        v-if="post.media.video?.muxPlaybackId"
        :video="post.media"
        :preview-start-time="0"
        :will-loop="true"
        :bg-video="true"
      />
      <DatoCmsImage
        v-else
        :data="post.type === 'article' ? post.media : post.media.responsiveImage"
        layout="fill"
        object-fit="cover"
        object-position="50% 50%"
        sizes="(max-width: 600px) 400px, 800px"
      />
    </div>
    <div :class="bem('post-titles')">
      <h5 :class="[bem('main-title'), 'heading-4']">{{ post.title }}</h5>
      <BaseCopy
        v-if="post.description"
        size="body-sm"
        :class="bem('description')"
      >
        {{ post.description }}
      </BaseCopy>
    </div>
  </NuxtLink>
</template>

<script setup>
import { Image as DatoCmsImage } from 'vue-datocms'
const { resolveLocalePath } = useUrlBuilder()
const { $track } = useNuxtApp()

const bem = useBEM('ImpactCarouselItem')
  
const props = defineProps({
  post: { type: Object, required: true },
  mobileLayout: {type: String, required: false, default: 'impact'},
  index: { type: Number, default: 0 },
  parentTrackingId: {type: String, required: false, default: 'Impact Carousel'}
})
  
async function handleLinkClick() {
  await $track.global.linkClicked({
    linkText: props.post.title,
    interactionElement: props.post.trackingId || props.post.title,
    interactionSection: props.parentTrackingId,
    interactionCategory: 'Impact Carousel',
    position: props.index + 1
  }, 'Clicked Impact Carousel Item')
}
</script>

<style lang="postcss">
.ImpactCarouselItem {
  @apply flex flex-col items-start gap-y-4 text-white;

  &--dark-mobile {
    @apply mdMax:text-black;
  }

  .swiper-slide:nth-child(even) & {
    .ImpactCarouselItem__post-media {
      @apply lg:aspect-[39/35]
    }

    .ImpactCarouselItem__post-titles {
      @apply max-w-[calc(420px_*_(39_/_35))]
    }
  }

  &:hover {
    .ImpactCarouselItem__main-title {
      @apply underline;
    }
  }
}

.ImpactCarouselItem__post-media {
  @apply flex items-center justify-center relative h-auto w-full aspect-[115/127]
  rounded-[10px] overflow-hidden;

  @screen md {
    @apply h-[420px] w-auto;
  }
}

.ImpactCarouselItem__post-titles {
  @apply flex flex-col items-start gap-y-1 w-full max-w-[calc(420px_*_(115_/_127))]
}
</style>
